/* eslint-disable no-param-reassign, arrow-body-style */
import axios from 'axios';

const state = {
  types: [],
};

const getters = {

  getTypes: (st) => {
    return st.types;
  },

  getType: st => (typeId) => {
    if (st.types.length === 0) return null;
    return st.types.find((typeObj) => {
      return typeObj.Type === typeId;
    });
  },

};

const mutations = {
  setTypes(st, payload) {
    st.types = payload;
  },
};

const actions = {
  fetchTypes({ commit }) {
    axios.get('objects/types')
      .then((res) => {
        commit('setTypes', res.data);
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/types.js